<template>
  <div>
    <v-row
    no-gutters
    class="mt-n2 d-flex align-center justify-center"
  >
    <v-col
      no-gutters
      cols="12"
    >
      <span
        no-gutters
        class="hb-font-caption"
        >{{ contatName }}</span
      >
    </v-col>
    <v-col
      no-gutters
      cols="12"
    >
      <span
        no-gutters
        class="hb-font-caption"
        >{{ localTime }}</span
      >
    </v-col>
  </v-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: 'DoNotRentAddedAtRenderer',
  data() {
    return {
    };
  },
  computed: {
    contatName() {
      let nameKey = this.params?.columnNames?.contactName || 'dnr_added_by';
      return this.params.data[nameKey];
    },
    localTime() {
      let timestampKey = this.params?.columnNames?.timestamp || 'dnr_added_at';
      return moment.utc(this.params.data[timestampKey]).local().format('MMM D, YYYY @ hh:mma');
    }
  },
};
</script>